<template>
  <ClientSkeleton v-if="isLoading" class="px-6 pb-6 pt-5" />
  <div class="container is-fluid py-5 px-6 min-h-90vh c-w-shell" v-else>
    <div class="is-flex is-justify-content-space-between mb-5">
      <div class="is-flex is-align-items-center is-clickable" @click="goBack()">
        <ArrowLeftIcon class="mr-3" />
        <p class="averta-bold is-size-5">Kembali</p>
      </div>
      <div class="is-flex is-align-items-center">
        <div class="mr-5 input-custom-1">
          <b-input
            style="width: 17em"
            :placeholder="`Cari nama ${renderTitle}`"
            type="search"
            icon="magnify"
            :value="getSearchValue"
            @input="updateSearchValue"
            @keyup.native.enter="
              tabActive === 'unit'
                ? getListBranch({ dontLoading: true })
                : tabActive === 'unit-price'
                ? getListUnitPrice({ refresh: true })
                : filterAreaK()
            "
          >
          </b-input>
        </div>
        <div class="is-relative">
          <div ref="listBranchAddButton">
            <ButtonApp
              v-if="tabActive === 'unit' || tabActive === 'unit-price'"
              @click="handleClickAddBtn"
              :is-bold="true"
              height="40px"
            >
              <div class="flex-center pr-1">
                <p class="averta-bold">+ Tambah {{ renderTitleButton }}</p>
                <div v-if="isUnitPrice" class="ml-2">
                  <img src="@/assets/icons/arrow-down-used.svg" alt="" />
                </div>
              </div>
            </ButtonApp>
          </div>
          <ButtonApp
            v-if="isSMRC && tabActive === 'areaCoordinator'"
            @click="handleAddAreaCoordinator"
            :is-bold="true"
            height="40px"
            width="254px"
          >
            + Tambah Area Koordinator
          </ButtonApp>

          <div
            v-if="isUnitPrice && openDropdownUnitPrice"
            class="unit-price-wrapper"
            v-closable="{
              exclude: ['listBranchAddButton'],
              handler: 'handleCloseUnitPrice'
            }"
          >
            <ButtonDropdownItem
              title="Tambah Daftar Cabang"
              @click="handleAddBranch"
            >
              <template v-slot:icon>
                <BranchIcon />
              </template>
            </ButtonDropdownItem>
            <div class="divider"></div>
            <ButtonDropdownItem
              title="Tambah Harga Satuan Item Pekerjaan"
              @click="handleUnitPrice"
            >
              <template v-slot:icon>
                <img
                  :src="require('@/assets/icons/store-2-red-used.svg')"
                  alt=""
                />
              </template>
            </ButtonDropdownItem>
          </div>
        </div>
      </div>
    </div>
    <BannerClient
      :client="dataClient"
      :areasName="areasName"
      :refreshData="getListBranch"
      :listBranch="listBranch"
    />
    <div v-if="tabActive !== 'areaCoordinator'" class="columns">
      <div
        class="column card col-1 p-3 m-2"
        v-for="(item, index) in getListDaftarBranchData"
        :key="index"
      >
        <img
          :src="require(`@/assets/img/${item.image}`)"
          alt="wave"
          class="wave"
        />
        <p class="is-size-5 averta-bold">{{ item.total }}</p>
        <p class="is-size-4 averta-black my-2">{{ item.listBranch }}</p>
      </div>
    </div>

    <div
      class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center c-w-100 gap-6"
    >
      <div class="flex-center-vertical c-w-100">
        <div
          class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center c-w-100 gap-2"
        >
          <div
            v-if="isSMRC || isUnitPrice"
            class="btn-tabs-2"
            @click="handleClickTab('unit')"
            :class="{ 'is-active': tabActive === 'unit' }"
          >
            <p>Daftar {{ renderTitleBranch }}</p>
          </div>
          <div
            v-if="isSMRC"
            class="btn-tabs-2"
            @click="handleClickTab('areaCoordinator')"
            :class="{ 'is-active': tabActive === 'areaCoordinator' }"
          >
            <p>Daftar Area Koordinator</p>
          </div>
          <div
            v-if="isUnitPrice"
            class="btn-tabs-2"
            @click="handleClickTab('unit-price')"
            :class="{ 'is-active': tabActive === 'unit-price' }"
          >
            <p>Harga Satuan Item Pekerjaan</p>
          </div>
        </div>
        <div
          v-if="
            !isLoadingUnitPrice && isUnitPrice && tabActive === 'unit-price'
          "
          class="is-flex is-flex-direction-row is-justify-content-flex-end is-align-items-center c-w-100 gap-2"
        >
          <b-dropdown
            :scrollable="isScrollable"
            :max-height="maxHeight"
            v-model="currentLimit"
            aria-role="list"
          >
            <template #trigger="{ active }">
              <b-button rounded :icon-right="active ? 'menu-up' : 'menu-down'">
                <p class="averta-regular label-14 px-4">
                  {{ currentLimit.label }} Data /Page
                </p>
              </b-button>
            </template>

            <b-dropdown-item
              v-for="(menu, index) in menus"
              :key="index"
              :value="menu"
              aria-role="listitem"
            >
              <div class="is-flex is-flex-direction-row">
                <div class="c-w-100">
                  <h3>{{ menu.label }}</h3>
                </div>
              </div>
            </b-dropdown-item>
          </b-dropdown>

          <div
            class="is-flex is-flex-direction-row is-justify-content-flex-end gap-2"
          >
            <b-field>
              <b-input
                icon="magnify"
                type="search"
                v-model="searchIDUnitPriceItemWorking"
                class="c-w-100"
                placeholder="Cari Berdasarkan Nama Item Pekerjaan"
                rounded
                @input="filterIDUnitPriceItemWorking"
                @keyup.enter.native="getDataFromSearch"
                @icon-right-click="clearSearchIDUnitPriceItemWorking"
              >
              </b-input>
              <p class="control">
                <b-button
                  type="is-primary"
                  label="Cari Data"
                  rounded
                  @click="getDataFromSearch()"
                />
              </p>
            </b-field>
          </div>
        </div>
      </div>

      <div class="c-w-100">
        <TabListAreaBranch
          v-if="tabActive === 'unit'"
          :listBranch="listBranch"
          :refreshData="getListBranch"
          :isSMRC="isSMRC"
          @detailBranch="detailBranch($event)"
          @handleEditBranch="handleEditBranch($event)"
        />

        <TabListAreaKoordinator
          v-if="isSMRC && tabActive === 'areaCoordinator'"
          :data="dataAreaKoordinator"
          :refreshData="getListAreaKoordinator"
        />

        <TableUnitPrice
          v-if="
            !isLoadingUnitPrice && isUnitPrice && tabActive === 'unit-price'
          "
          :data="dataUnitPrice"
          :initialData="initUnitPrice"
          :refreshData="getListUnitPrice"
          :totalDataUnitPrice="totalDataUnitPrice"
          :totalPageUnitPrice="totalPageUnitPrice"
          :currentPageUnitPrice="currentPageUnitPrice"
          :currentLimit="currentLimit"
          :infoText="infoText"
        />

        <div
          v-else-if="!isSMRC"
          class="column c-w-100 has-text-centered"
          style="display: none"
        >
          <ProyekEmptyIcon />
          <p class="averta-bold mt-2">Data Tidak Ditemukan</p>
        </div>
      </div>
    </div>

    <SidebarBranch
      :show="showSidebar"
      :close="handleCloseSidebar"
      @refreshListBranch="getListBranch"
    />
    <SidebarEditBranch
      :show="showSidebarEdit"
      :close="handleCloseSidebarEdit"
      :selectedBranch="selectedBranch"
      @updateBranch="getListBranch"
    />
    <SidebarAddPICBranch
      type="area-koordinator"
      :show="showSidebarCoordinator"
      :close="handleCloseSidebarAreaCoordinator"
      @reloadData="getListAreaKoordinator($event)"
    />

    <b-loading
      :is-full-page="true"
      :active="isLoadingAreaC || isLoadingUnitPrice"
      :can-cancel="false"
    >
      <SpinnerIcon />
    </b-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  AREACOORD,
  BRANCH_SMRC,
  BRANCH,
  AREA_KOORDINATOR_SMRC,
  PIC_STORE
} from '@/helpers/constants'
import { titleBranch, alertErrorMessage, isSMRC } from '@/helpers'

import {
  ArrowLeftIcon,
  BranchIcon,
  ProyekEmptyIcon,
  SpinnerIcon
} from '@/components/icons'
import { ListDaftarBranchData } from '@/data/views/listbranchData'

import ButtonApp from '@/components/button/ButtonApp.vue'
import ButtonDropdownItem from '@/components/button/ButtonDropdownItem'
import BannerClient from './components/BannerClient.vue'
import ClientSkeleton from '@/components/skeleton/ClientSkeleton.vue'

import SidebarBranch from './components/SidebarBranch.vue'
import SidebarAddPICBranch from './components/branch-components/SidebarAddPICBranch.vue'
import SidebarEditBranch from './components/branch-components/SidebarEditBranch.vue'

import TabListAreaBranch from './components/store-components/TabListAreaBranch.vue'
import TabListAreaKoordinator from './components/area-koordinator-components/TabListAreaKoordinator.vue'
import TableUnitPrice from './components/unit-price-components/TableUnitPriceV2.vue'

export default {
  name: 'ListBranch',
  components: {
    ArrowLeftIcon,
    BranchIcon,
    ProyekEmptyIcon,
    SpinnerIcon,

    ButtonApp,
    ButtonDropdownItem,
    BannerClient,
    ClientSkeleton,

    SidebarBranch,
    SidebarEditBranch,
    SidebarAddPICBranch,

    TabListAreaBranch,
    TabListAreaKoordinator,
    TableUnitPrice
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl'
    }),
    pathDetailBranch () {
      const path = this.$route.path.split('/')
      const lastElement = path[path.length - 1]

      if (lastElement === 'detail-branch') return true
      return false
    },
    getListDaftarBranchData () {
      return ListDaftarBranchData(this.listBranch)
    },
    renderTitleButton () {
      return this.isUnitPrice
        ? 'Data'
        : titleBranch(this.listBranch.code || '')
    },
    isSMRC () {
      return isSMRC(this.listBranch.code)
    },
    renderTitle () {
      let temp
      if (this.isSMRC) {
        if (this.tabActive === 'unit') {
          temp = BRANCH_SMRC
        } else if (this.tabActive === 'unit-price') {
          temp = 'Item Pekerjaan'
        } else {
          temp = AREA_KOORDINATOR_SMRC
        }
      } else {
        if (this.tabActive === 'unit') {
          temp = BRANCH
        } else if (this.tabActive === 'unit-price') {
          temp = 'Item Pekerjaan'
        } else {
          temp = PIC_STORE
        }
      }
      return temp
    },
    renderTitleBranch () {
      return isSMRC ? BRANCH_SMRC : BRANCH
    },
    getSearchValue () {
      if (this.tabActive === 'unit') {
        return this.searchUnit
      } else if (this.tabActive === 'unit-price') {
        return this.searchUnitPrice
      } else {
        return this.searchAreaK
      }
    },
    isUnitPrice () {
      return this.dataClient && this.dataClient.is_use_unit_price
    }
  },
  data () {
    return {
      isLoading: false,
      isLoadingAreaC: false,
      isLoadingUnitPrice: false,
      searchUnit: null,
      searchAreaK: null,
      searchUnitPrice: null,
      listBranch: null,
      showSidebar: false,
      showSidebarEdit: false,
      showSidebarCoordinator: false,
      selectedBranch: null,
      dataClient: null,
      areasName: null,
      tabActive: 'unit',
      initAreaKoordinator: [],
      dataAreaKoordinator: [],
      openDropdownUnitPrice: false,
      initUnitPrice: [],
      dataUnitPrice: [],
      searchIDUnitPriceItemWorking: '',
      pages: 1,
      limitPage: 10,
      hasMore: true,
      isLoadingMore: false,
      isScrollable: false,
      maxHeight: 200,
      currentLimit: { label: 10 },
      totalDataUnitPrice: 0,
      totalPageUnitPrice: 0,
      currentPageUnitPrice: 1,
      infoText: null,
      menus: [
        { label: 10 },
        { label: 25 },
        { label: 50 },
        { label: 75 },
        { label: 100 },
        { label: 125 },
        { label: 150 },
        { label: 175 },
        { label: 200 }
      ]
    }
  },

  methods: {
    handleClickTab (tab) {
      this.tabActive = tab
    },
    goBack () {
      if (this.$route.query.unitPrice) {
        if (this.isSMRC) {
          this.$router.push(`/am/vendors/${this.$route.params.vendorId}/area`)
        } else {
          this.$router.push('/am/vendors')
        }
      } else {
        this.$router.go(-1)
      }

      const clearBranch = {
        type: 'clearPayload',
        data: {
          clientSelected: {},
          branchName: '',
          dataPic: []
        }
      }

      const clearPicBranch = {
        type: 'clearPayload',
        data: {
          clientSelected: {},
          branchSelected: {},
          dataPic: []
        }
      }

      this.$store.commit('client/setPayloadAddBranch', clearBranch)
      this.$store.commit('client/setPayloadAddPicBranch', clearPicBranch)
    },
    detailBranch (branchId, data) {
      this.$router.push(`/am/vendors/${branchId}/store`)
    },
    getListBranch (props) {
      if (!props || !props.dontLoading) {
        this.isLoading = true
      }

      const payload = {
        url: this.url,
        vendor_id: this.$route.params.vendorId
      }

      if (this.$route.query.area_id) {
        payload.area_id = this.$route.query.area_id
      }

      this.$store
        .dispatch('client/getListBranch', payload)
        .then(response => {
          const res = response.data.data
          this.listBranch = res

          const clientSelected = {
            company_name: res.company_name,
            name: res.name,
            logo: res.logo,
            id: this.$route.params.vendorId
          }

          if (res.code) {
            clientSelected.code = res.code
          }

          this.areasName = response.data.data.area

          this.dataClient = {
            name: res.name,
            company_name: res.company_name,
            logo: res.logo,
            client_type_code: res.client_type_code,
            client_type_name: res.client_type_name
          }

          if (res.is_use_unit_price) {
            this.dataClient.is_use_unit_price = res.is_use_unit_price
          }

          // Tambah response detail client
          this.$store.commit('client/setPayloadAddBranch', {
            type: 'clientSelected',
            clientSelected: clientSelected
          })
          this.$store.commit('client/setPayloadAddPicBranch', {
            type: 'clientSelected',
            clientSelected: clientSelected
          })
          this.$store.commit('client/setDetailClient', {
            data: clientSelected
          })
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          alertErrorMessage(error)
        })
    },
    getListAreaKoordinator () {
      this.isLoadingAreaC = true
      const payload = {
        url: this.url,
        vendor_id: this.$route.params.vendorId,
        area_id: this.$route.query.area_id,
        role_id: AREACOORD
      }

      this.$store
        .dispatch('client/getUserRoleSMRC', payload)
        .then(response => {
          const res = response.data.data
          this.initAreaKoordinator = JSON.parse(JSON.stringify(res))
          this.dataAreaKoordinator = res
          this.isLoadingAreaC = false
        })
        .catch(error => {
          alertErrorMessage(error)
          this.isLoadingAreaC = false
        })
    },
    getListUnitPrice (props) {
      if (!props || !props.hideLoading) {
        this.isLoadingUnitPrice = true
      }

      const payload = {
        url: this.url,
        vendor_id: this.$route.params.vendorId,
        limit: this.currentLimit.label,
        page: this.currentPageUnitPrice
      }

      if (props.page) {
        payload.page = props.page
      }

      if (this.searchIDUnitPriceItemWorking) {
        payload.search = this.searchIDUnitPriceItemWorking
      }

      if (props?.sortBy && props?.sortType) {
        payload.sort_by = props.sortBy
        payload.sort_type = props.sortType
      }

      this.$store
        .dispatch('unitPrice/getListItemWorkingUnitPrice', payload)
        .then(response => {
          const res = response.data.data

          this.totalDataUnitPrice = response.data.total_data
          this.totalPageUnitPrice = response.data.total_page
          this.currentPageUnitPrice = response.data.current_page

          const start =
            (this.currentPageUnitPrice - 1) * this.currentLimit.label + 1
          const end = Math.min(
            this.currentPageUnitPrice * this.currentLimit.label,
            this.totalDataUnitPrice
          )

          if (this.searchIDUnitPriceItemWorking) {
            this.infoText = `Menampilkan data berdasarkan pencarian ${this.searchIDUnitPriceItemWorking} (${start} - ${end} dari ${this.totalDataUnitPrice} data)`
          } else {
            this.infoText = `Menampilkan ${start} - ${end} dari ${this.totalDataUnitPrice} data`
          }

          if (props?.refresh) {
            this.initUnitPrice = [...res]
            this.dataUnitPrice = [...res]
          } else {
            this.initUnitPrice.push(...res)
            this.dataUnitPrice.push(...res)
          }

          this.hasMore = this.currentPageUnitPrice < this.totalPageUnitPrice

          this.isLoadingUnitPrice = false
          this.isLoadingMore = false
        })
        .catch(error => {
          alertErrorMessage(error)
          this.isLoadingUnitPrice = false
        })
    },
    handleClickAddBtn () {
      this.isUnitPrice ? this.handleAddUnitPrice() : this.handleAddBranch()
    },
    handleAddBranch () {
      this.openDropdownUnitPrice = false
      this.showSidebar = true
      this.$store.commit('client/setAddBranchFromList', true)
    },
    handleAddUnitPrice () {
      this.openDropdownUnitPrice = !this.openDropdownUnitPrice
    },
    handleCloseUnitPrice () {
      this.openDropdownUnitPrice = false
    },
    handleCloseSidebar () {
      this.showSidebar = false
    },
    handleCloseSidebarEdit () {
      this.showSidebarEdit = false
      this.selectedBranch = null
    },
    handleEditBranch (data) {
      this.showSidebarEdit = true
      this.selectedBranch = data
    },
    handleAddAreaCoordinator () {
      this.showSidebarCoordinator = true
    },
    handleCloseSidebarAreaCoordinator () {
      this.showSidebarCoordinator = false
    },
    handleUnitPrice () {
      this.$router.push(`/am/form-unit-price/${this.$route.params.vendorId}`)
    },
    updateSearchValue (value) {
      if (this.tabActive === 'unit') {
        this.searchUnit = value
      } else if (this.tabActive === 'unit-price') {
        this.searchUnitPrice = value
      } else {
        this.searchAreaK = value
      }
    },
    filterAreaK () {
      const filter = this.initAreaKoordinator.filter(item => {
        return item.name.toLowerCase().includes(this.searchAreaK.toLowerCase())
      })

      this.dataAreaKoordinator = filter
    },
    clearQuery () {
      const query = this.$route.query.type
      if (query) {
        this.tabActive = query
      }
      setTimeout(() => {
        const query = Object.assign({}, this.$route.query)
        if (query.type) {
          delete query.type
          this.$router.replace({ query })
        }
      }, 200)
    },
    filterIDUnitPriceItemWorking () {
      this.searchIDUnitPriceItemWorking = this.searchIDUnitPriceItemWorking.trim()
      this.$store.commit(
        'client/setSearchIDUnitPriceItemWorking',
        this.searchIDUnitPriceItemWorking
      )
    },
    getDataFromSearch () {
      this.getListUnitPrice({
        refresh: true,
        hideLoading: true
      })
    },
    clearSearchIDUnitPriceItemWorking () {
      this.searchIDUnitPriceItemWorking = ''
      this.getDataFromSearch()
    }
  },
  created () {
    this.$store.commit('client/setPayloadAddPicBranch', {
      type: 'branchSelected',
      branchSelected: {}
    })
    this.getListBranch()
    this.getListAreaKoordinator()
    this.getListUnitPrice({ sortBy: 'created_at', sortType: 'desc' })
  },
  mounted () {
    this.clearQuery()
  },
  watch: {
    searchUnit (newValue) {
      if (newValue === '') {
        this.getListBranch({ dontLoading: true })
      }
    },
    searchPic (newValue) {
      if (newValue === '') {
        this.dataPicFilter = {
          branch: this.initListStore.branch,
          pics: this.initListStore.pics
        }
      }
    },
    currentLimit (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.totalDataUnitPrice = null
        this.totalPageUnitPrice = null
        this.currentPageUnitPrice = 1
        this.getListUnitPrice({
          refresh: true,
          hideLoading: true
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.col-1 {
  background: linear-gradient(90deg, #ed4949 0%, #a40707 100%);
  border-radius: 20px;
  color: white;
}

.wave {
  object-fit: cover;
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 0;
  left: 0;
  border-radius: 20px;
}

.wrapper-vendor {
  background: #f7f7f7;
  border-radius: 18px;
}

.border-right {
  border-right: 2px #eaeaea solid;
}

.btn-detail {
  border-radius: 20px;
  color: #eb4600;
  background: white;
  border: 1px solid #eb4600;
  padding-top: 14px;
  padding-bottom: 14px;
  font-family: "Averta-Bold";
  font-size: 16px;
  width: 100%;
}

.list-branch {
  height: 245px;
}

.branch-name {
  height: 60px;
}

.branch-name p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.unit-price-wrapper {
  width: 18em;
  position: absolute;
  top: 3em;
  right: 0;
  z-index: 2;
  background: $color-white;
  padding: 15px 10px;
  border: 1px solid $color-grey-3;
  border-radius: 20px;
  box-shadow: 0px 6px 24px 0px #2525251a;
}

.divider {
  border: 1px solid $color-grey-3;
  margin: 10px 0;
}
</style>
